var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            { staticClass: "m-0 mt-2" },
            [
              _c(
                "b-col",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "validation-observer",
                    { ref: "requestForm" },
                    [
                      _c(
                        "b-form",
                        {
                          staticClass: "mb-1 mt-2",
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.saveForm($event)
                            }
                          }
                        },
                        [
                          _c("h4", { staticClass: "mt-2 mb-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm._.get(_vm.dataForm, "type_form_str", "")
                              )
                            )
                          ]),
                          _c("vs-divider"),
                          _vm.typeForm === "CA"
                            ? _c("RequestFormIncidentCoupAttempt", {
                                ref: "coupAttempt",
                                attrs: {
                                  typeForm: _vm.typeForm,
                                  dataForm: _vm.dataForm,
                                  disabledFields: _vm.disabledFields
                                }
                              })
                            : _vm._e(),
                          _vm.typeForm === "GE"
                            ? _c("RequestFormIncidentGeneral", {
                                ref: "general",
                                attrs: {
                                  typeForm: _vm.typeForm,
                                  dataForm: _vm.dataForm,
                                  disabledFields: _vm.disabledFields
                                }
                              })
                            : _vm._e(),
                          _c("div", { staticClass: "mt-1 mb-2" }, [
                            _c(
                              "div",
                              { staticClass: "flex justify-end" },
                              [
                                !_vm.disabledFields
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "ripple",
                                            rawName: "v-ripple.400",
                                            value: "rgba(255, 255, 255, 0.15)",
                                            expression:
                                              "'rgba(255, 255, 255, 0.15)'",
                                            modifiers: { "400": true }
                                          }
                                        ],
                                        staticClass: "mt-1 mr-1 float-right",
                                        attrs: {
                                          variant: "primary",
                                          disabled: !_vm.validateForm
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.saveForm()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("save")) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "ripple",
                                        rawName: "v-ripple.400",
                                        value: "rgba(255, 255, 255, 0.15)",
                                        expression:
                                          "'rgba(255, 255, 255, 0.15)'",
                                        modifiers: { "400": true }
                                      }
                                    ],
                                    staticClass: "mt-1 mr-1 float-right",
                                    attrs: { variant: "outline-secondary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.$router.push(
                                          "/incident-form"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }